export class WorkloadEligibleAgentEntity {
  public userId!: string;
  public firstName!: string;
  public lastName!: string;
  public email!: string;
  public currentCaseCount!: number;
  public effectiveCapacity!: number;
}
